<template>
    <div class="course_div_box pt60 base-bg">
        <div class="clearfix">
            <router-view/>
        </div>
    </div>
</template>

<script>
    export default {
        name: "contest"
    }
</script>

<style scoped>
    .clearfix {
        display: flex;
        flex-wrap: wrap;
        width: 1170px;
        margin-left: auto;
        margin-right: auto;
        margin-top: 30px;
        margin-bottom:30px;
    }
</style>
